export const SortDirections = {
    data() {
        return {
            ASCENDING: 'asc',
            DESCENDING: 'desc',
        }
    }
}
